/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react'
import './permissions.css'
import { Auth } from 'aws-amplify'
import searchListService from '../../Services/Queries/ListUsersinESService'
import listUserPermissionsService from '../../Services/Queries/listUserPermissionsService'
import { FiEdit2 } from 'react-icons/fi'
import GetAllPermissionsList from '../../Services/Queries/userPermissionsListService'
import PermissionsPopUp from './PermissionsPopUp'
function Permissions() {
  const [show, setShow] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [roleNamesForEachPerson, setRoleNamesForEachPerson] = useState([])
  const [RolesandPermissionsArray, setSserRolesandPermissionsArray] = useState([])
  const [PermissionsList, setPermissionsList] = useState()
  const [searchValue, setSearchValue] = useState('')
  const [selectedUserPermissions, setSelectedUserPermissions] = useState([])
  const [userList, setUserList] = useState()
  const [sendRowData, setSendRowData] = useState()
  const rolesArray = [...roleNamesForEachPerson]
  const userRolesandPermissionsArray = [...RolesandPermissionsArray]
  const editPermissions = async (pemissionsData, item) => {
    setSendRowData(item)
    setShow(true)

    setSelectedUserPermissions(pemissionsData === null ? [] : pemissionsData)
  }

  const searchedData = e => {
    setSearchValue(e.target.value)
  }

  const clearHandle = () => {
    setSearchValue('')
    getUserDetails()
  }

  const searchHandle = async () => {
    const input = {
      from: 0,
      limit: 1,
      search: searchValue,
      currentLoggedInUserID: Auth.user.username,
    }
    const autoSuggestionsSearch = await searchListService(input)
    setUserList(autoSuggestionsSearch)
  }

  // const cssBorders = {
  //   main: {
  //     padding: '5px',
  //     height: '1rem',
  //     border: '1px solid rgb(224, 224, 224)',
  //   },
  // }

  const getUserDetails = async () => {
    setIsLoading(true)
    const UserData = await listUserPermissionsService()
    UserData &&
      UserData.map(item => {
        const index1 = UserData.findIndex(value => value.PK === null)
        if (index1 > -1) {
          UserData.splice(index1, 1)
          return UserData
        }
      })

    userList &&
      userList.map(item => {
        userRolesandPermissionsArray.push(item.roleName)
        setSserRolesandPermissionsArray(userRolesandPermissionsArray)
        item.userRolesAndPermissions &&
          item.userRolesAndPermissions.map(value => {
            rolesArray.push(value.roleName)
            setRoleNamesForEachPerson(rolesArray)
          })
      })
    setUserList(UserData)
    setIsLoading(false)
    // setPermissionsList(UserData)
  }

  const getPermissionsList = async () => {
    const popUpPermissionLIst = await GetAllPermissionsList()

    setPermissionsList(popUpPermissionLIst)
  }

  const reloadPermissions = async () => {
    if (searchValue) {
      await searchHandle()
    } else {
      await getUserDetails()
    }
  }

  useEffect(() => {
    getUserDetails()
    const getDynamicPermissionsList = async () => {
      await getPermissionsList()
    }

    getDynamicPermissionsList()
  }, [])

  return (
    <div className='d-flex flex-column gap-5'>
      <div className='d-flex gap-3'>
        <input value={searchValue} onChange={searchedData} className='form-control ' />

        <button
          onClick={searchHandle}
          disabled={searchValue.length < 2}
          className='btn btn-primary'
        >
          Search
        </button>

        <button onClick={clearHandle} className='btn btn-primary'>
          Clear
        </button>
      </div>
      <div>
        {(userList && userList.length === 0) || userList === null ? (
          'No Users Available'
        ) : (
          <table className='tableclassName'>
            <tr className='trMain'>
              <th className='text-center thTag'>S.No</th>
              <th className='text-center thTag'>User Name</th>
              <th className='text-center thTag'>User Handle</th>
              <th className='text-center thTag'>Mobile Number</th>
              <th className='text-center thTag'>Permissions</th>
            </tr>
            {userList !== null &&
              userList !== undefined &&
              userList.map((item, index) => (
                <tr className='column' key={item}>
                  <td className='tdTag'>{index + 1}</td>
                  <td className='tdTag'>{item.name}</td>
                  <td className='tdTag'>{item.handle}</td>
                  <td className='tdTag'>{item.mobileNumber}</td>
                  <td className='tdPermissions'>
                    <div className='d-flex'>
                      <div className='permissionDiv'>
                        {item.userRolesAndPermissions &&
                          item.userRolesAndPermissions.map(item => (
                            <>
                              {item.permissions.map((value, index) => (
                                <div key={index}>
                                  <span>{value.name}</span>,
                                </div>
                              ))}
                            </>
                          ))}
                      </div>
                    </div>
                    <FiEdit2
                      className='editButton'
                      onClick={() => editPermissions(item.userRolesAndPermissions, item)}
                    />
                  </td>
                </tr>
              ))}
          </table>
          // table
        )}
        {show && (
          <PermissionsPopUp
            reloadPermissions={reloadPermissions}
            userRolesandPermissionsArray={userRolesandPermissionsArray}
            rolesArray={rolesArray}
            sendRowData={sendRowData}
            selectedUserPermissions={selectedUserPermissions}
            PermissionsList={PermissionsList}
            show={show}
            setShow={setShow}
          />
        )}
      </div>
      {isLoading ? (
        <div className='loading-overlay'>
          <span className='fas fa-spinner fa-3x fa-spin'></span>
        </div>
      ) : (
        ''
      )}
    </div>
  )
}

export default Permissions
